import $api2 from '@/plugins/axiosInstance2.js'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  


    GET_ADVANVEPAYMENT_LIST: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: `/admin/advancepayment`, params: payload})
            .then(result =>{return result.data})
        }
    },

    GET_ADVANVEPAYMENT_DETAIL: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: `/admin/advancepayment/${payload.id}`, params: payload.params})
            .then(result =>{return result.data})
        }
    },
    GET_ADVANVEPAYMENT_ALBUM: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: `/admin/advancepayment/${payload.id}/album`, params: payload.params})
            .then(result =>{return result.data})
        }
    },
    GET_ADVANVEPAYMENT_MEMO: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: `/admin/advancepayment/${payload.id}/memo`, params: payload.params})
            .then(result =>{return result.data})
        }
    },
    DELETE_ADVANVEPAYMENT_ALBUM: {
        root: true,
        handler(namespacedContext, payload) {
        return $api2({ method: 'delete', url: `/admin/advancepayment/${payload.id}/album/${payload.album_id}`})
            .then(result =>{return result.data})
        }
    },
    POST_ADVANVEPAYMENT_ALBUM: {
        root: true,
        handler(namespacedContext, payload){
            return $api2({method: "post", url:`/admin/advancepayment/${payload.id}/album`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
    PUT_ADVANVEPAYMENT_MEMO: {
        root: true,
        handler(namespacedContext, payload){
            return $api2({method: "put", url:`/admin/advancepayment/${payload.id}`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
    
    // GET_TRANSFER_DETAIL: {
    //     root: true,
    //     handler(namespacedContext, payload) {
    //     return $api({ method: 'get', url: `/transfer/${payload.id}`, params: payload.params})
    //         .then(result =>{return result.data})
    //     }
    // },
    // GET_TRANSFER_DETAIL_ALBUM: {
    //     root: true,
    //     handler(namespacedContext, payload) {
    //     return $api({ method: 'get', url: `/transfer/${payload.id}/album`, params: payload.params})
    //         .then(result =>{return result.data})
    //     }
    // },
    // POST_TRANSFER: {
    //     root: true,
    //     handler(namespacedContext, payload){
    //         return $api({method: "post", url:`/transfer`, data: payload.params})
    //         .then(result =>{
    //         return result
    //         })
    //     }
    // },
    // PUT_TRANSFER_DETAIL_MEMO: {
    //     root: true,
    //     handler(namespacedContext, payload){
    //         return $api({method: "put", url:`/transfer/${payload.id}`, data: payload.params})
    //         .then(result =>{
    //         return result.data
    //         })
    //     }
    // },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
